"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { listAgentBackends, deleteAgentBackend, type AgentBackend } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DeleteConfirmDialog } from "@/components/delete-confirm-dialog";
import { RequireRole } from "@/components/auth/require-role";

export default function AgentBackendsPage() {
  const [backends, setBackends] = useState<AgentBackend[]>([]);

  useEffect(() => {
    listAgentBackends().then(setBackends);
  }, []);

  async function handleDelete(id: string) {
    await deleteAgentBackend(id);
    setBackends((prev) => prev.filter((b) => b.id !== id));
  }

  return (
    <div className="flex min-h-full flex-col p-6">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">智能体服务</h1>
        <RequireRole roles={["owner"]}>
          <Button asChild size="sm">
            <Link href="/agent-backends/create">创建</Link>
          </Button>
        </RequireRole>
      </div>

      {backends.length === 0 ? (
        <div className="flex flex-1 items-center justify-center text-muted-foreground">
          暂无智能体服务。
          <RequireRole roles={["owner"]}>
            {" "}
            <Link href="/agent-backends/create" className="ml-1 underline">
              立即创建
            </Link>
          </RequireRole>
        </div>
      ) : (
        <ul className="space-y-2">
          {backends.map((b) => (
            <li key={b.id} className="flex items-center gap-2">
              <Link
                href={`/agent-backends/${b.id}`}
                className="block flex-1 rounded-lg border px-4 py-3 transition-colors hover:bg-muted"
              >
                <span className="font-medium">{b.display_name || b.id}</span>
                <span className="ml-2 text-sm text-muted-foreground">{b.endpoint}</span>
                <span className="ml-2 text-xs text-muted-foreground">短标识： {b.slug}</span>
              </Link>
              <RequireRole roles={["owner"]}>
                <DeleteConfirmDialog
                  title={`确认删除智能体服务“${b.display_name || b.id}”？`}
                  description="此操作将永久删除该智能体服务配置，且无法撤销。"
                  onConfirm={() => handleDelete(b.id)}
                />
              </RequireRole>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
